define.alias("checkout/components/add-ons/change", "settings/components/add-ons/change");